import { Component } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';
import { ContratoService } from '../../../../../providers/contrato-service';
import { AlertService } from '../../../../../providers/alert-service';
import { MenuService } from '../../../../../providers/menu-service';
import { ModulosController } from '../../../modulos-controller';
import { UsuarioService } from '../../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../../providers/gestao-pca-service';

@Component({
  selector: 'page-extensao-prazos-contratuais-acima-limite-regulamentado',
  templateUrl: 'extensao-prazos-contratuais-acima-limite-regulamentado.html',
  providers: [
    ContratoService
  ]
})
export class ExtensaoPrazosContratuaisAcimaLimiteRegulamentadoPage extends ModulosController {
  listaDados: any;
  loading: boolean = true;
  submetendoNoCertificado: boolean = false;
  idSecaoPagina: string = "53";
  page1: number = 1;
  page2: number = 1;
  page3: number = 1;
  page4: number = 1;
  page5: number = 1;
  page: number = 1;

  order1: string = 'contrato.nmContrato';
  reverse1: boolean = true;
  order2: string = 'contrato.nmContrato';
  reverse2: boolean = true;
  order3: string = 'contrato.nmContrato';
  reverse3: boolean = true;
  order4: string = 'contrato.nmContrato';
  reverse4: boolean = true;
  order5: string = 'contrato.nmContrato';
  reverse5: boolean = true;

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public navParams: NavParams,
    public contratoService: ContratoService,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.carregarDados();

    this.setModuloId(5);
    this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
  }

  setOrder1(value: string) {
    if (this.order1 === value) {
      this.reverse1 = false;
      this.order1 = "-" + value;
    } else {
      this.reverse1 = true;
      this.order1 = value;
    }
  }

  setOrder2(value: string) {
    if (this.order2 === value) {
      this.reverse2 = false;
      this.order2 = "-" + value;
    } else {
      this.reverse2 = true;
      this.order2 = value;
    }
  }

  setOrder3(value: string) {
    if (this.order3 === value) {
      this.reverse3 = false;
      this.order3 = "-" + value;
    } else {
      this.reverse3 = true;
      this.order3 = value;
    }
  }

  setOrder4(value: string) {
    if (this.order4 === value) {
      this.reverse4 = false;
      this.order4 = "-" + value;
    } else {
      this.reverse4 = true;
      this.order4 = value;
    }
  }

  setOrder5(value: string) {
    if (this.order5 === value) {
      this.reverse5 = false;
      this.order5 = "-" + value;
    } else {
      this.reverse5 = true;
      this.order5 = value;
    }
  }

  carregarDados() {
    this.contratoService.obterDadosExtensaoAcimaLimite().subscribe(data => {
      this.listaDados = data;
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });
  }

  formatarPorcentagem(valor) {
    return valor.toString().replace('.', ',') + "%";
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  voltar() {
    this.menuService.redirecionarPagina(this.contratoService.obterIdPaginaContrato());
  }

  salvarComentario(enviarMensagem = true) {
    this.loading = true;
    if (this.listaDados) {
      this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
      this.contratoService.salvarDadosExtensaoAcimaLimite(this.listaDados, this.idSecaoPagina).subscribe(data => {

        if (enviarMensagem) {
          this.alertService.mostraAlerta("", "Salvo com sucesso.");
        }
        this.loading = false;
      }, error => {
        if (enviarMensagem) {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
        }
        this.loading = false;
      });
    }
  }

  submeterNoCertificado() {
    this.loading = true;
    if (this.listaDados.resultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.resultadoAnalise == null || this.listaDados.resultadoAnalise == undefined || !this.listaDados.resultadoAnalise) {
      this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
      this.loading = false;
    } else {
      if (this.listaDados) {
        this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
        this.contratoService.finalizarExtensaoAcimaLimite(this.listaDados, this.idSecaoPagina).subscribe(data => {
          this.alertService.mostraAlerta("", "Submetido com sucesso.");
          this.voltar();
        }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
          this.loading = false;
        });
      }
    }
  }

  truncateText(text) {
    let numberOfWordsToTruncate = 20;

    if (text != undefined) {
      let separatedByWords = text.toString().split(" ");

      if (this.needTruncate(text)) {
        return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
      }
      else {
        return text;
      }
    }
  }

  needTruncate(text) {
    let separatedByWords = text.toString().split(" ");
    let numberOfWordsToTruncate = 20;

    return separatedByWords.length >= numberOfWordsToTruncate;
  }

  exibirCompleto(text) {
    this.alertService.mostraAlerta('', text);
  }

  formatarZeroEsquerda(valor) {
    return valor.replace(/^0+(?!\.|$)/, '');
  }

  capitalize(str) {
    let retorno = "";

        if (str) {
            retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }

        return retorno;
  }

  calcularDiferencaDatas(aditivo) {
    let diferenca = 0;
    let assinatura;
    let vigencia;

    if (aditivo.assinatura) {
      assinatura = new Date(aditivo.assinatura.split("/").reverse().map(Number));
    }

    if (aditivo.novaDataVigencia) {
      vigencia = new Date(aditivo.novaDataVigencia.split("/").reverse().map(Number));
    }

    if (aditivo.assinatura && aditivo.novaDataVigencia) {
      var diff = Math.abs(vigencia.getTime() - assinatura.getTime());
      diferenca = Math.ceil(diff / (1000 * 3600 * 24));
    }

    return diferenca;
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos/contrato-analise/extensao-prazos-contratuais-acima-limite-regulamentado/extensao-prazos-contratuais-acima-limite-regulamentado.ts